import { Gender } from 'src/api/requests'

export const GenderShortMap = {
  [Gender.MALE]: 'M',
  [Gender.FEMALE]: 'F',
  [Gender.UNKNOWN]: '-'
}
